<div class="search-page">
    <div class="search-page__title">
        <h2>{{title}}</h2>
    </div>
    <div class="search-page__content">
        <app-search-box [title]="title" [siteKey]="siteKey" (showTratamientoDatos)="openTratamientoDatos()" (submited)="onSearchSubmit($event)"></app-search-box>
    </div>
</div>
@if(loader || error || tratamientoDatosIsOpen ){
    <div class="overlay">
        @if(loader){
        <div class="overlay--content overlay__loader">
            <app-loader></app-loader>
        </div>
        }
        <!--@if(error){
        <div class="overlay&#45;&#45;content overlay__modal">
            <span class="overlay__modal&#45;&#45;close" [attr.tabindex]="0" (click)="closeError()" ></span>
            <div class="modal__container">
                <div class="modal__container&#45;&#45;icon">
                    <span></span>
                </div>
                <div class="modal__container&#45;&#45;content">
                    <div class="modal__container&#45;&#45;content&#45;&#45;title">
                        <span>Documento no encontrado</span>
                    </div>
                    <div class="modal__container&#45;&#45;content&#45;&#45;description">
                        <p>{{errorModalMessage}}</p>
                    </div>
                </div>
            </div>
        </div>
        }-->
        @if (tratamientoDatosIsOpen) {
            <div class="overlay--content overlay__modal overlay__modal--tratamiento-datos">
                <span class="overlay__modal--close" [attr.tabindex]="0" (click)="closeTratamientoDatos()" ></span>
                <div class="modal__container">
                    <div class="modal__container--content">
                        <app-tratamiento-datos />
                    </div>
                </div>
            </div>
        }
        <div class="overlay__backdrop"></div>
    </div>
}
